"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var geometry_1 = require("../geometry");
var utils_1 = require("../template/utils");
var BaseBarChart = /** @class */ (function (_super) {
    __extends(BaseBarChart, _super);
    function BaseBarChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Whether the chart is horizontally layouted, i.e. gravity is left or right. */
        _this._isHorizontal = false;
        /** Whether the scale should be inversed, i.e. gravity is bottom or right. */
        _this._isInversed = false;
        /**
         * The thickness of each bar. If user set -1 (i.e. auto) for _thickness, this will be calculated automatically.
         * For grouped bar chart, this is the total thickness of all sub-bars.
         */
        _this._thick = -1;
        return _this;
    }
    BaseBarChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_gravity":
                return {
                    top: __1.Gravity.Top, bottom: __1.Gravity.Bottom, left: __1.Gravity.Left, right: __1.Gravity.Right,
                }[value];
            case "_minValue":
            case "_maxValue":
            case "_thickness":
            case "_gap":
                return utils_1.parseNumberWithAuto(value);
            case "_valueFunc":
            case "_categoryFunc":
            case "_subValueFunc":
                return utils_1.parseFunc(value);
            case "_subCategories":
                return utils_1.parseJSON(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    BaseBarChart.prototype.defaultOptions = function () {
        return {
            _gravity: __1.Gravity.Bottom,
            _thickness: -1,
            _gap: 5,
            _minValue: 0,
            _maxValue: -1,
            _valueFunc: function (d) { return d; },
            _valueFunc_isFunc: false,
            _categoryFunc: function (_, i) { return i.toString(); },
            _categoryFunc_isFunc: false,
            _subCategories: [],
        };
    };
    BaseBarChart.prototype.init = function () {
        this.scale = d3.scaleLinear();
        this._groups = this.appendGroupT(_1.Component).data([]).options({
            _x: this._getXOrY(true),
            _y: this._getXOrY(false),
            _width: this._getWidthOrHeight(true),
            _height: this._getWidthOrHeight(false),
        });
    };
    BaseBarChart.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        var gravity = this.getOption("_gravity");
        this._isHorizontal = gravity === __1.Gravity.Left || gravity === __1.Gravity.Right;
        this._isInversed = gravity === __1.Gravity.Bottom || gravity === __1.Gravity.Right;
        var size = this.computedSize();
        this._cachedWidth = size.width;
        this._cachedHeight = size.height;
        var totalX = this._isHorizontal ? this._cachedHeight : this._cachedWidth;
        var totalY = this._isHorizontal ? this._cachedWidth : this._cachedHeight;
        var gap = this._gap = this.getOption("_gap");
        this._valueFunc = this.getOption("_valueFunc");
        this._groups.options("_anchor", this.gravityToAnchor(gravity));
        this.scale.domain([this._getMin(), this._getMax()]);
        this.scale.range(this._isInversed ? [totalY, 0] : [0, totalY]);
        var thick = this.getOption("_thickness");
        if (thick < 0) {
            // auto thickness
            var n = this._getBarCount();
            // length = n * thick + (n - 1 + axisNum) * gap
            this._thick = (totalX - n * gap) / n;
        }
        else {
            this._thick = thick;
        }
        this._groups.data(this.datum);
        this.setupProxy({
            valueAxis: function (axis) {
                axis.options({
                    _scale: _this.scale,
                    _scale_isFunc: false,
                    _gravity: _this._isHorizontal ? __1.Gravity.Top : __1.Gravity.Left,
                });
            },
            categoryAxis: function (axis) {
                var tickFunc = _this.getOption("_categoryFunc");
                axis.options({
                    _scale: d3.scaleBand().domain(_this.datum.map(tickFunc)).range([0, totalX]),
                    _scale_isFunc: false,
                    _gravity: gravity,
                    _x: gravity === __1.Gravity.Right ? _this._cachedWidth : 0,
                    _y: gravity === __1.Gravity.Bottom ? _this._cachedHeight : 0,
                    _includeStartEndTicks: false,
                });
            },
        });
    };
    BaseBarChart.prototype._getBarCount = function () {
        return this.datum.length;
    };
    BaseBarChart.prototype._getMax = function () {
        var maxVal = this.getOption("_maxValue");
        var v = this.getOption("_valueFunc");
        return maxVal > 0 ? maxVal : d3.max(this.datum, v);
    };
    BaseBarChart.prototype._getMin = function () {
        var minVal = this.getOption("_minValue");
        return minVal;
    };
    BaseBarChart.prototype._getXOrY = function (horizontal) {
        var _this = this;
        return function (d, i) {
            if (horizontal === _this._isHorizontal) {
                switch (_this.getOption("_gravity")) {
                    case __1.Gravity.Top: return 0;
                    case __1.Gravity.Bottom: return _this._cachedHeight;
                    case __1.Gravity.Left: return 0;
                    case __1.Gravity.Right: return _this._cachedWidth;
                }
            }
            else {
                return _this._gap * 0.5 + _this._thick * 0.5 + i * (_this._thick + _this._gap);
            }
        };
    };
    BaseBarChart.prototype._getWidthOrHeight = function (horizontal) {
        var _this = this;
        return function (d, i) {
            if (horizontal === _this._isHorizontal) {
                var v = _this.scale(_this.getOption("_valueFunc")(d));
                if (_this._isInversed) {
                    return _this._isHorizontal ? _this._cachedWidth - v : _this._cachedHeight - v;
                }
                return v;
            }
            else {
                return _this._thick;
            }
        };
    };
    BaseBarChart.prototype.gravityToAnchor = function (g) {
        switch (g) {
            case __1.Gravity.Top: return 2 /* Top */ | 32 /* Center */;
            case __1.Gravity.Bottom: return 8 /* Bottom */ | 32 /* Center */;
            case __1.Gravity.Left: return 16 /* Left */ | 4 /* Middle */;
            case __1.Gravity.Right: return 64 /* Right */ | 4 /* Middle */;
        }
    };
    return BaseBarChart;
}(_1.Component));
exports.BaseBarChart = BaseBarChart;
var BarChart = /** @class */ (function (_super) {
    __extends(BarChart, _super);
    function BarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarChart.prototype.init = function () {
        _super.prototype.init.call(this);
        this._rects = this._groups.appendT(element_1.Rect).options({
            _anchor: 2 /* Top */ | 16 /* Left */,
            _x: 0,
            _y: 0,
            _width: geometry_1.GeometryValue.fullSize,
            _height: geometry_1.GeometryValue.fullSize,
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _anchor: 8 /* Bottom */ | 32 /* Center */,
            _relatedTo: 2 /* Top */ | 32 /* Center */,
            _x: 0,
            _y: 0,
            _text: function (d) { return d; },
        });
    };
    BarChart.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this.setupProxy({
            bar: "_rects",
            label: "_labels",
        });
    };
    BarChart.prototype.postOptionsUpdate = function () {
        _super.prototype.postOptionsUpdate.call(this);
        var gravity = this.getOption("_gravity");
        var isHorizontal = gravity === __1.Gravity.Left || gravity === __1.Gravity.Right;
        var isInversed = gravity === __1.Gravity.Bottom || gravity === __1.Gravity.Right;
        var getAnchor = function (isInversed) {
            return (isHorizontal ? 4 /* Middle */ : (isInversed ? 8 /* Bottom */ : 2 /* Top */)) |
                (isHorizontal ? (isInversed ? 64 /* Right */ : 16 /* Left */) : 32 /* Center */);
        };
        this._labels.options({
            _anchor: getAnchor(isInversed),
            _relatedTo: getAnchor(!isInversed),
        });
    };
    return BarChart;
}(BaseBarChart));
exports.BarChart = BarChart;
var BarChartGrouped = /** @class */ (function (_super) {
    __extends(BarChartGrouped, _super);
    function BarChartGrouped() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isStacked = true;
        _this._subCategoryCount = 0;
        _this._cachedY = 0;
        return _this;
    }
    BarChartGrouped.prototype.defaultOptions = function () {
        return __assign({ _groupType: "stacked", _categoryFunc: null, _subCategories: [], _subValueFunc: null }, _super.prototype.defaultOptions.call(this));
    };
    BarChartGrouped.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        var getSubData = function (d, i) {
            var v = _this.getOption("_subValueFunc");
            var c = _this.getOption("_subCategories");
            return c.map(function (k) { return v(d, i, k); });
        };
        var getX = this._getSubXOrY(true);
        var getY = this._getSubXOrY(false);
        this._subRects = this._groups.appendGroupT(element_1.Rect).data(getSubData).options({
            // Dirty hack. Since _x and _y will apply earlier for each group of elements, reset cachedY here.
            _x: function (d, i) { if (i === 0) {
                _this._cachedY = 0;
            } return getX(d, i); },
            _y: function (d, i) { if (i === 0) {
                _this._cachedY = 0;
            } return getY(d, i); },
            _width: this._getSubWidthOrHeight(true),
            _height: this._getSubWidthOrHeight(false),
        });
    };
    BarChartGrouped.prototype.prepare = function () {
        var _this = this;
        var c = this.getOption("_subCategories");
        this._isStacked = this.getOption("_groupType") === "stacked";
        this._subCategoryCount = c.length;
        _super.prototype.prepare.call(this);
        this.setupProxy({
            subBar: function (proxy) {
                _this._subRects.options(proxy.getAllOptions());
            },
        });
    };
    BarChartGrouped.prototype.postOptionsUpdate = function () {
        this._subRects.options("_anchor", this.gravityToAnchor(this.getOption("_gravity")));
    };
    BarChartGrouped.prototype._getMax = function () {
        var maxVal = this.getOption("_maxValue");
        var v = this.getOption("_subValueFunc");
        var c = this.getOption("_subCategories");
        if (this.getOption("_groupType") === "stacked") { // stacked
            return maxVal > 0 ? maxVal : d3.max(this.datum, function (d, i) { return c.map(function (k) { return v(d, i, k); }).reduce(function (a, b) { return a + b; }, 0); });
        }
        else { // grouped
            return maxVal > 0 ? maxVal : d3.max(this.datum, function (d, i) { return d3.max(c.map(function (k) { return v(d, i, k); })); });
        }
    };
    BarChartGrouped.prototype._getWidthOrHeight = function (horizontal) {
        return 0;
    };
    BarChartGrouped.prototype._getSubWidthOrHeight = function (horizontal) {
        var _this = this;
        var superFn = _super.prototype._getWidthOrHeight.call(this, horizontal);
        return function (d, i) {
            var v = superFn(d, i);
            if (horizontal === _this._isHorizontal) {
                _this._cachedY += v;
                return v;
            }
            else if (horizontal !== _this._isHorizontal) {
                return _this._isStacked ? v : v / _this._subCategoryCount;
            }
        };
    };
    BarChartGrouped.prototype._getSubXOrY = function (horizontal) {
        var _this = this;
        return function (d, i) {
            if (_this._isStacked) {
                return horizontal === _this._isHorizontal ? (_this._isInversed ? -_this._cachedY : _this._cachedY) : 0;
            }
            else {
                return horizontal === _this._isHorizontal ? 0 : (_this._thick / _this._subCategoryCount) * (i - _this._subCategoryCount / 2 + 0.5);
            }
        };
    };
    return BarChartGrouped;
}(BaseBarChart));
exports.BarChartGrouped = BarChartGrouped;
//# sourceMappingURL=bar-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/bar-chart.js
// module id = 421
// module chunks = 0 1